/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
// import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'

import { Grid } from "@material-ui/core";
  import { SiMicrosoftexcel } from 'react-icons/si';
import styles from './ProjectMasterReport.module.css'
import { 
  CustomDatePicker, 
  CustomFormGroup, 
  CustomSelect, 
  ValidatingTextField 
} from '../FormComponents'
import { 
  DATE_FORMAT, 
  API_RESOURCE_URLS, 
  DISPLAY_MESSAGES, 
  MESSAGE_TYPE, 
  RESOURCE_TYPE, 
  USER_OPERATIONS, 
  Regex 
} from '../../constants'

import Truckloading from "../../components/CvLoader/Cvloader";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';


function ProjectMasterReport() {
const auth = useSelector((state) => state.auth); // useSelector
const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
const { showPopup } = usePopupManager();

  const dispatch= useDispatch();

  const [loading, setLoading] = useState(false);

   const baseDefaultColumns = [
    {title: 'Project Code', field: 'project_code'},
    {title: 'Project Code Desc', field: 'project_code_desc'},
    {title: 'Gate Code', field: 'gate_code'},
    {title: 'Gate Description', field: 'gate_description'},
    {title: 'Gate Status', field: 'gate_status'},
    {title: 'Wbs Description', field: 'wbs_desc'},
    {title: 'Status', field: 'status'},
    {title: 'BU', field: 'bu'},
    {title: 'SUB BU', field: 'sub_bu'},
    {title: 'Platform', field: 'platform'},
    {title: 'Family', field: 'family'}
  ];

  const exportToExcel = () => {

    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
   
      setLoading(true);
      fetch(`${baseUrl}master/ProjectMaster`, {
        method: "GET",
        headers: headerss,
        credentials:"include"
        // body: apiFormatedDataJson,
      })
      
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        setLoading(false);

        console.log("Api Master Data: ", responseJson.data);
        if(responseJson.msg=="Success" && responseJson?.data.length !== 0) {
          const exportData = responseJson.data.map(item => {
            const {id, ...rest} = item;
            const reorderedItem = {};
            baseDefaultColumns.forEach(mapping => {
                reorderedItem[mapping.title] = rest[mapping.field];
            });
            return reorderedItem;
          })
          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.json_to_sheet(exportData);
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, 'Project_Master_Report.csv');

        }else{
          setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data Not Found",
          })
        }

      }).catch((error) => {
        setLoading(false);
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Oops! Something went wrong. Please try again later",
            })
          });
    };

  
  const renderOther = () => (
    <div className="">
    <Grid
      container
      rowSpacing={2}
      style={{ marginTop: "2px" }}
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item md={6} lg={6} style={{ textAlign: 'right' }}>
        <div className="">
          <p><strong>Project Master Report Download Here : </strong></p>
        </div>
      </Grid>
      <Grid item md={6} lg={6} style={{ textAlign: 'left' }}>
        <div className="">
            <Button
              className={clsx(styles.actionButton)}
              variant="primary"
              data-testid="confirm-action"
              onClick={() => exportToExcel()}
              startIcon={<SiMicrosoftexcel />}
              style={{ marginLeft: "12px" }}
            >
              Export Report
            </Button>
          </div>
      </Grid>
    </Grid>
  </div>
  );


  return (
    <>
      <div className={styles.formContainer}>
          <CustomFormGroup header='Project Master Report' body={renderOther()} />
        {
          loading ? (
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                 <Truckloading />
              </div>):""
        }

      </div>
      </>
  );
};

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});

ProjectMasterReport.propTypes = {
  redirectToProcessPage: PropTypes.func,
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ProjectMasterReport);

export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);

